import React, { Component } from 'react';
import { BASEURL } from '../../constant';
import config from "../../API/DomainName";

class Unsubscribe extends Component {
    constructor(props) {
        super(props);
        this.state = {
            token: this.props.match.params.token,
            succuess: false
        };
    }
    componentDidMount() {
        let subscribe = JSON.stringify({
            token: this.state.token,
        });
        fetch(config.register + 'user/auth/unsubscribe', {
            method: 'POST',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            body: subscribe,
        })
            .then(response => response.json())
            .then(data => {
                console.log('Success:', data);
                if (data.status == 1) {
                    this.setState({
                        succuess: true
                    });
                } else {
                    let toastr = "";
                    toastr = window.toastr.error;
                    toastr(data.msg, {
                        positionClass: "toast-bottom-center",
                        containerId: "toast-bottom-center",
                    });
                    setTimeout(function () {
                        window.location.href = '/';
                    }, 1000);
                }
            });
    }

    handleChange = (e) => {
        const propName = e.target.name;
        this.setState({ [e.target.name]: e.target.value });

    };

    render() {

        return (
            <React.Fragment>
                <div className=''>
                    <div className='row no-margin'>
                        <div className='col-md-12'>
                            {this.state.succuess && (
                                <div>
                                    <div className='text-center'>
                                        <a className='subscribepage' href='/'>
                                            <img src='/assets/images/bewiselogo.png' alt='logo'/>
                                        </a>
                                    </div>
                                    <div className='text-center'>
                                        <h2>Thank you</h2>
                                        <p>
                                            You have been removed from our newsletter subscriber list.
                                            You will not receive any further newsletter email from us.
                                        </p>
                                        <p>
                                            Did you unsubscribe by accident? <a href={BASEURL + '#footera'}>Re-subscribe</a>
                                        </p>
                                        <p>
                                            <a href={BASEURL}>Return to Homepage</a>
                                        </p>
                                    </div>
                                </div>
                            )}

                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default Unsubscribe;




// WEBPACK FOOTER //
// ./src/components/Copyrights/unsubscribe.jsx